import $ from 'jquery'

var setOp = {
    getProductId(url) {
        var array = url.split(`-`);
        return array[array.length - 1];
    },
    toTitles(s) {
        return s.replace(/\w\S*/g, function (t) {
            return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
        });
    },
    hideLoader() {
        $(`body`).removeClass(`vld-shown`);
        $(`.vld-overlay`).parent().remove();
    },   
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }, 
    recreateFooterText(companyName, link, phone){      
        var href = `<a target='_blank' href='${link}'>${companyName}</a>`;           

        var footerText1 = $(`#footer-1`).text();        
        var finalText1 = footerText1.replace("{link}", href);
        $(`#footer-1`).html(finalText1)

        var footerText2 = $(`#footer-2`).text();            
        var finalText2 = footerText2.replace("{link}", href).replace("{phone}", phone);
        $(`#footer-2`).html(finalText2)
    },
    clearHtml(html) {
        var temporalDivElement = document.createElement("div");
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = html;
        // Retrieve the text property of the element (cross-browser support)
        return temporalDivElement.textContent /*.replace("<script", "[script")*/ || temporalDivElement.innerText/*.replace("<script", "[script")*/ || "";
    }
}

export default setOp